import React from 'react';

import styles from './LoadingState.module.scss';

export const LoadingState: React.FC = () => (
  <div className={styles.loadingState}>
    <h1 className={styles.pageTitle}>Latest Articles</h1>

    <div className={styles.contentWrapper}>
      <aside className={styles.sidebar}>
        {[...Array(13)].map((_, i) => (
          <div key={i} className={styles.sidebarItem}></div>
        ))}
      </aside>

      <main className={styles.mainContent}>
        <div className={styles.heroCard}></div>
        <div className={styles.subCard}></div>
        <div className={styles.subCard}></div>
      </main>
    </div>
  </div>
);
